import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NoSesssionAuthPage from '../Layouts/Shared/_NoSesssionAuthPage.jsx';

export default function ChangedLanguage() {

    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        navigate('/dashboard');
    }, [navigate]);

    return (
        <NoSesssionAuthPage title={t('pages.login.title')} >
            <React.Fragment>
            </React.Fragment>
        </NoSesssionAuthPage>
    )

}